import { paymentTransactionSettingService } from "../services";
import { paymentTransactionSettingConstants } from "../constants";
import { alertActions } from ".";

export const paymentTransactionSettingActions = {
  getAll,
  createSetting,
  updateSetting,
  onHideShow,
  loadingData,
};

function getAll(obj) {
  return (dispatch) => {
    dispatch(request());
    paymentTransactionSettingService.fetchSettingData(obj).then(
      (response) => {
        dispatch(loadingData(false));
        dispatch(success(response.ResponseData));
      },
      (error) => {
        dispatch(loadingData(false));
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: paymentTransactionSettingConstants.GETALL_REQUEST };
  }
  function success(datas) {
    return { type: paymentTransactionSettingConstants.GETALL_SUCCESS, datas };
  }
  function failure(error) {
    return { type: paymentTransactionSettingConstants.GETALL_FAILURE, error };
  }
}

function createSetting(data) {
  return (dispatch) => {
    dispatch(request(data));

    return paymentTransactionSettingService.createSetting(data).then(
      (response) => {
        if (response && response.ResponseCode) {
          if (response.ResponseCode === "200") {
            dispatch(success(response.ResponseData));
            dispatch(onHideShow(false));
            dispatch(alertActions.success(response.ResponseMessage));
            return response;
          } else if (response.ResponseCode === "400") {
            dispatch(alertActions.warning(response.ResponseMessage));
            throw new Error(response.ResponseMessage);
          } else {
            dispatch(alertActions.error(response.ResponseMessage));
            throw new Error(response.ResponseMessage);
          }
        }
        return response;
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
        throw error;
      }
    );
  };

  function request(data) {
    return { type: paymentTransactionSettingConstants.CREATE_REQUEST, data };
  }
  function success(data) {
    return { type: paymentTransactionSettingConstants.CREATE_SUCCESS, data };
  }
  function failure(error) {
    return { type: paymentTransactionSettingConstants.CREATE_FAILURE, error };
  }
}

function updateSetting(data) {
  return (dispatch) => {
    dispatch(request(data));

    return paymentTransactionSettingService.updateSetting(data).then(
      (response) => {
        if (response && response.ResponseCode) {
          if (response.ResponseCode === "200") {
            dispatch(success(data));
            dispatch(onHideShow(false));
            dispatch(alertActions.success(response.ResponseMessage));
            return response;
          } else if (response.ResponseCode === "400") {
            dispatch(alertActions.warning(response.ResponseMessage));
            throw new Error(response.ResponseMessage);
          } else {
            dispatch(alertActions.error(response.ResponseMessage));
            throw new Error(response.ResponseMessage);
          }
        }
        return response;
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
        throw error;
      }
    );
  };

  function request(data) {
    return { type: paymentTransactionSettingConstants.UPDATE_REQUEST, data };
  }
  function success(data) {
    return { type: paymentTransactionSettingConstants.UPDATE_SUCCESS, data };
  }
  function failure(error) {
    return { type: paymentTransactionSettingConstants.UPDATE_FAILURE, error };
  }
}

function onHideShow(isbool) {
  return {
    type: paymentTransactionSettingConstants.DIALOG_REQUEST,
    isbool,
  };
}

function loadingData(isbool) {
  return {
    type: paymentTransactionSettingConstants.LOADING_REQUEST,
    isbool,
  };
}
